import React, { Component } from 'react';
import './ContactUsStyles.css'

class ContactUs extends Component {



    submitOnClick = () => {
        window.location.href = "#popup1"
    }

    render() {
        return (
            <div>

                <div id="popup1" className="overlay">
                    <div className="popup">
                        <h2 className="txt-main">Email Sent successfully</h2>
                        <a className="close" href="#">&times;</a>
                        <div className="content text-center">
                            Thank you for contacting us. We will reply as soon as we can.
                            <br />
                            You can close this window now :)
		                </div>
                    </div>
                </div>
                <div className="container">
                    <div className="container">
                        <div className="container contact ">
                            <div className="row">
                                <div className="card col-md-3 bg-main text-white main-shadow">

                                    <div className="contact-info">

                                        <h1 className="text-center text-white">තුරු</h1>
                                        <h1 className="text-center text-white">Contact Us</h1>
                                        <h4 className="text-center text-white">We would love to hear from you !</h4>
                                    </div>
                                </div>
                                <div className=" card col-md-9">
                                    <div className="contact-form">
                                        <div className="form-group">
                                            <label className="control-label col-sm-2" htmlFor="fname">First Name:</label>
                                            <div className="col-sm-10">
                                                <input type="text" className="form-control" id="fname" placeholder="Enter First Name" name="fname" />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="control-label col-sm-2" htmlFor="lname">Last Name:</label>
                                            <div className="col-sm-10">
                                                <input type="text" className="form-control" id="lname" placeholder="Enter Last Name" name="lname" />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="control-label col-sm-2" htmlFor="email">Email:</label>
                                            <div className="col-sm-10">
                                                <input type="email" className="form-control" id="email" placeholder="Enter email" name="email" />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="control-label col-sm-2" htmlFor="comment">Comment:</label>
                                            <div className="col-sm-10">
                                                <textarea className="form-control" rows={5} id="comment" defaultValue={""} />
                                            </div>
                                        </div>


                                        <button onClick={this.submitOnClick} type="submit" className="btn-submit col-sm-10 btn btn-lg btn-block ">Send Email</button>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>





        );
    }
}

export default ContactUs;
